const COOKIE_CONSENT_KEY = "cookie_consent";

interface ConsentPreferences {
  necessary: boolean;
  analytics: boolean;
  version: string;
  timestamp: number;
}

export function getCookieConsent(): ConsentPreferences | null {
  try {
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!stored) return null;
    return JSON.parse(stored) as ConsentPreferences;
  } catch {
    return null;
  }
}

export function hasAnalyticsConsent(): boolean {
  const consent = getCookieConsent();
  return consent?.analytics === true;
}
